import moment from 'moment';

export interface FlightState {
  publicAreaList: PublicAreaData | undefined;
  flightPlanArea: FlightPlanArea | undefined;
  list: [FlightPlanData] | undefined;
  detail: FlightPlanData | undefined;
  pilotList: FlightPlanPilotDataList | undefined;
  arcrftList: FlightPlanArcrftDataList | undefined;
  pilotSelect: PilotSelectData | undefined;
  arcrftSelect: FlightPlanArcrftData | undefined;
  areaCoordList: FlightPlanAreaData[] | undefined;
  areaList: FlightPlanAreaData[] | undefined;
  aprvList: [FlightPlanData] | undefined;
  aprvProc: any | undefined;
  scheduleList: BasFlightScheduleList[] | [];
  page: number | 1;
  total: number | 0;
  conut: number | 0;
  weather: resweatherData | undefined;
  selectGroup: SelectGroupData | undefined;
  listSelect: ListGroupData | undefined;
  aprvSelect: ListGroupData | undefined;
  uamBufferList: FlightUamBufferList[] | undefined;
}
export interface weatherData {
  serviceKey: string;
  numOfRows: string;
  pageNo: string;
  dataType: string;
  base_date: string;
  base_time: string;
  nx: string;
  ny: string;
}
export interface resweatherData {
  resultCode: string;
  resultMsg: string;
  numOfRows: string;
  pageNo: string;
  totalCount: string;
  dataType: string;
  baseDate: string;
  baseTime: string;
  fcstDate: string;
  fcstTime: string;
  category: string;
  fcstValue: string;
  nx: string;
  ny: string;
  hstryAreaSno: string;
  area1: string;
  area2: string;
  area3: string;
  zipCd: string;
  landNm: string;
  landNum: string;
  areaType: string;
  areaNm: string;
}

export interface SelectGroupData {
  cstmrSno: number;
  groupId: string;
  groupNm: string;
  search1: string;
  stDate: string;
  endDate: string;
}

export interface ListGroupData {
  cstmrSno: number;
  groupId: string;
  groupNm: string;
}

export interface PublicAreaData {
  publicAreaList: [];
}

export interface FlightPlanArea {
  address: string;
  coordinates: string;
  redius: string;
  altitude_m: string;
  altitude_ft: string;
}

export interface FlightPlanData {
  planSno?: number;
  groupId: string;
  cstmrSno: number;
  memberName: string;
  email: string;
  hpno: string;
  clncd: string;
  addr: string;
  addrDtlCn: string;
  zip: string;
  schFltStDt: string;
  schFltEndDt: string;
  fltPurpose: string;
  aprvlYn: string;
  delYn: string;
  createUserId: string;
  createDt: string;
  updateUserId: string;
  updateDt: string;
  areaList?: FlightPlanAreaDataList | undefined;
  pilotList?: FlightPlanPilotDataList | undefined;
  arcrftList?: FlightPlanArcrftDataList | undefined;
  // docState: string
}

export interface FlightPlanAreaData {
  planAreaSno?: number;
  planSno: number;
  areaType: string;
  fltMethod: string;
  bufferZone: number;
  fltElev: string;
  createUserId?: string;
  createDt?: string;
  updateUserId?: string;
  updateDt?: string;
  coordList?: FlightPlanAreaCoordDataList | undefined;
  bufferCoordList?: FlightPlanAreaCoordDataList | undefined;
  // docState: string,
}

export interface FlightPlanAreaDataList extends Array<FlightPlanAreaData> {}

export interface FlightPlanAreaCoordData {
  planAreaCoordSno?: number;
  planAreaSno?: number;
  lat: number;
  lon: number;
  createUserId?: string;
  createDt?: string;
  // docState: string
}

export interface FlightPlanAreaCoordDataList
  extends Array<FlightPlanAreaCoordData> {}

export interface FlightPlanPilotData {
  planPilotSno?: number;
  planSno?: number;
  cstmrSno?: number;
  groupNm: string;
  memberName: string;
  email: string;
  hpno: string;
  clncd: string;
  addr: string;
  addrDtlCn: string;
  zip: string;
  qlfcNo: string;
  carrer: string;
  createUserId: string;
  createDt: string;
  updateUserId: string;
  updateDt: string;
  // docState: string
}

export interface FlightPlanPilotDataList extends Array<FlightPlanPilotData> {}

export interface FlightPlanArcrftData {
  planArcrftSno: number;
  planSno: number;
  arcrftSno: number;
  idntfNum: string;
  groupNm: string;
  prdctNum: string;
  arcrftTypeCd: string;
  arcrftModelNm: string;
  prdctCmpnNm: string;
  prdctDate: string;
  arcrftLngth: number;
  arcrftWdth: number;
  arcrftHght: number;
  arcrftWght: number;
  wghtTypeCd: string;
  imageUrl: string;
  takeoffWght: number;
  useYn: string;
  cameraYn: string;
  insrncYn: string;
  ownerNm: string;
  createUserId: string;
  createDt: string;
  updateUserId: string;
  updateDt: string;
  // docState: string
}

export interface FlightPlanArcrftDataList extends Array<FlightPlanArcrftData> {}

// rq
export interface FlightPlanListRqData {
  groupId: string;
  cstmrSno: number;
  schFltStDt: string;
  schFltEndDt: string;
  aprvlYn: string;
  page: number;
}

export interface FlightPlanAprovRqData {
  planSnoList: [number];
  aprvlYn: string;
}

export interface PilotSelectData {
  groupNm: string;
  cstmrSno: string;
  memberName: string;
  email: string;
  hpno: string;
  clncd: string;
  addr: string;
  addrDtlCn: string;
  zip: string;
}

export interface BasFlightAprovData {
  planSnoList: [number];
  aprvlYn: string;
}

export interface BasFlightScheduleList {
  groupId: string;
  groupNm: string;
  memberName: string;
  ownerNm: string;
  idntfNum: string;
  schFltStDt: string;
  schFltEndDt: string;
}

export interface BasFlightScheduleData {
  count: number;
  list: [BasFlightScheduleList];
}

export interface FlightUamBufferRq {
  buffer: number;
  coordinates: {
    x: number;
    y: number;
  }[];
}

export interface FlightUamBufferList {
  x: number;
  y: number;
  m: number | string;
  z: number | string;
}

export const initFlight = {
  weather: undefined,
  page: 1,
  total: 0,
  conut: 0,
  selectGroup: {
    cstmrSno: 0,
    groupId: '',
    groupNm: '',
    search1: '',
    stDate: '',
    endDate: ''
  },
  listSelect: {
    cstmrSno: 0,
    groupId: '',
    groupNm: ''
  },
  aprvSelect: {
    cstmrSno: 0,
    groupId: '',
    groupNm: ''
  },
  publicAreaList: undefined,
  flightPlanArea: undefined,
  list: undefined,
  detail: {
    planSno: 0,
    groupId: '',
    cstmrSno: 0,
    memberName: '',
    email: '',
    hpno: '',
    clncd: '+82',
    addr: '',
    addrDtlCn: '',
    zip: '',
    schFltStDt: moment()
      .set({ h: 0, m: 0, s: 0 })
      .format('YYYY-MM-DD HH:mm:ss'),
    schFltEndDt: moment()
      .set({ h: 0, m: 0, s: 0 })
      .format('YYYY-MM-DD HH:mm:ss'),
    fltPurpose: '',
    aprvlYn: '',
    delYn: '',
    createUserId: '',
    createDt: '',
    updateUserId: '',
    updateDt: '',
    areaList: [
      {
        planAreaSno: 0,
        planSno: 0,
        areaType: '',
        fltMethod: '',
        bufferZone: 0,
        fltElev: '',
        createUserId: '',
        createDt: '',
        updateUserId: '',
        updateDt: '',
        coordList: [
          {
            planAreaCoordSno: 0,
            planAreaSno: 0,
            lat: 0,
            lon: 0,
            createUserId: '',
            createDt: ''
          }
        ],
        bufferCoordList: [
          {
            planAreaCoordSno: 0,
            planAreaSno: 0,
            lat: 0,
            lon: 0,
            createUserId: '',
            createDt: ''
          }
        ]
      }
    ],

    pilotList: [
      {
        planPilotSno: 0,
        planSno: 0,
        cstmrSno: 0,
        groupNm: '',
        memberName: '',
        email: '',
        hpno: '',
        clncd: '+82',
        addr: '',
        addrDtlCn: '',
        zip: '',
        qlfcNo: '',
        carrer: '',
        createUserId: '',
        createDt: '',
        updateUserId: '',
        updateDt: ''
      }
    ],
    arcrftList: [
      {
        planArcrftSno: 0,
        planSno: 0,
        arcrftSno: 0,
        idntfNum: '',
        groupNm: '',
        prdctNum: '',
        arcrftTypeCd: '',
        arcrftModelNm: '',
        prdctCmpnNm: '',
        prdctDate: '',
        arcrftLngth: 0,
        arcrftWdth: 0,
        arcrftHght: 0,
        arcrftWght: 0,
        wghtTypeCd: '',
        imageUrl: '',
        takeoffWght: 0,
        useYn: '',
        cameraYn: '',
        insrncYn: '',
        ownerNm: '',
        createUserId: '',
        createDt: '',
        updateUserId: '',
        updateDt: ''
      }
    ]
  },
  pilotList: undefined,
  arcrftList: undefined,
  pilotSelect: undefined,
  arcrftSelect: undefined,
  areaCoordList: undefined,
  areaList: undefined,
  aprvList: undefined,
  aprvProc: undefined,
  scheduleList: [],
  uamBufferList: []
};

export const initFlightBas = {
  page: 1,
  total: 0,
  plan: {
    planSno: 0,
    groupId: '',
    cstmrSno: 0,
    memberName: '',
    email: '',
    hpno: '',
    clncd: '+82',
    addr: '',
    addrDtlCn: '',
    zip: '',
    schFltStDt: moment()
      .set({ h: 0, m: 0, s: 0 })
      .format('YYYY-MM-DD HH:mm:ss'),
    schFltEndDt: moment()
      .set({ h: 0, m: 0, s: 0 })
      .format('YYYY-MM-DD HH:mm:ss'),
    fltPurpose: '',
    aprvlYn: '',
    delYn: '',
    createUserId: '',
    createDt: '',
    updateUserId: '',
    updateDt: '',
    areaList: undefined,
    pilotList: undefined,
    arcrftList: undefined
  },
  pilot: {
    planPilotSno: 0,
    planSno: 0,
    cstmrSno: 0,
    groupNm: '',
    memberName: '',
    email: '',
    hpno: '',
    clncd: '+82',
    addr: '',
    addrDtlCn: '',
    zip: '',
    qlfcNo: '',
    carrer: '',
    createUserId: '',
    createDt: '',
    updateUserId: '',
    updateDt: ''
  },
  arcrft: {
    planArcrftSno: 0,
    planSno: 0,
    arcrftSno: 0,
    idntfNum: '',
    groupNm: '',
    prdctNum: '',
    arcrftTypeCd: '',
    arcrftModelNm: '',
    prdctCmpnNm: '',
    prdctDate: '',
    arcrftLngth: 0,
    arcrftWdth: 0,
    arcrftHght: 0,
    arcrftWght: 0,
    wghtTypeCd: '',
    imageUrl: '',
    takeoffWght: 0,
    useYn: '',
    cameraYn: '',
    insrncYn: '',
    ownerNm: '',
    createUserId: '',
    createDt: '',
    updateUserId: '',
    updateDt: ''
  },
  area: {
    planAreaSno: 0,
    planSno: 0,
    areaType: '',
    fltMethod: '',
    bufferZone: 0,
    fltElev: '',
    createUserId: '',
    createDt: '',
    updateUserId: '',
    updateDt: '',
    coordList: undefined
  },
  coord: {
    planAreaCoordSno: 0,
    planAreaSno: 0,
    lat: 0,
    lon: 0,
    createUserId: '',
    createDt: ''
  },
  initDetail: {
    planSno: 0,
    groupId: '',
    cstmrSno: 0,
    memberName: '',
    email: '',
    hpno: '',
    clncd: '+82',
    addr: '',
    addrDtlCn: '',
    zip: '',
    schFltStDt: moment()
      .set({ h: 0, m: 0, s: 0 })
      .format('YYYY-MM-DD HH:mm:ss'),
    schFltEndDt: moment()
      .set({ h: 0, m: 0, s: 0 })
      .format('YYYY-MM-DD HH:mm:ss'),
    fltPurpose: '',
    aprvlYn: '',
    delYn: '',
    createUserId: '',
    createDt: '',
    updateUserId: '',
    updateDt: '',
    areaList: [
      {
        planAreaSno: 0,
        planSno: 0,
        areaType: '',
        fltMethod: '',
        bufferZone: 0,
        fltElev: '',
        createUserId: '',
        createDt: '',
        updateUserId: '',
        updateDt: '',
        coordList: [
          {
            planAreaCoordSno: 0,
            planAreaSno: 0,
            lat: 0,
            lon: 0,
            createUserId: '',
            createDt: ''
          }
        ],
        bufferCoordList: [
          {
            planAreaCoordSno: 0,
            planAreaSno: 0,
            lat: 0,
            lon: 0,
            createUserId: '',
            createDt: ''
          }
        ]
      }
    ],
    pilotList: [
      {
        planPilotSno: 0,
        planSno: 0,
        cstmrSno: 0,
        groupNm: '',
        memberName: '',
        email: '',
        hpno: '',
        clncd: '+82',
        addr: '',
        addrDtlCn: '',
        zip: '',
        qlfcNo: '',
        carrer: '',
        createUserId: '',
        createDt: '',
        updateUserId: '',
        updateDt: ''
      }
    ],
    arcrftList: [
      {
        planArcrftSno: 0,
        planSno: 0,
        arcrftSno: 0,
        idntfNum: '',
        groupNm: '',
        prdctNum: '',
        arcrftTypeCd: '',
        arcrftModelNm: '',
        prdctCmpnNm: '',
        prdctDate: '',
        arcrftLngth: 0,
        arcrftWdth: 0,
        arcrftHght: 0,
        arcrftWght: 0,
        wghtTypeCd: '',
        imageUrl: '',
        takeoffWght: 0,
        useYn: '',
        cameraYn: '',
        insrncYn: '',
        ownerNm: '',
        createUserId: '',
        createDt: '',
        updateUserId: '',
        updateDt: ''
      }
    ]
  }
};
